<template>
    			<el-card class="deal_matter common_matter">
					<div class="title">
						<p>待办事项<i class="el-icon-refresh" @click="dealReflash"></i></p>
						<!-- <div class="title_nav" v-show="isShow">
							<p @click="navClickHandle(item.value,item.label)" v-for="(item,i) in navList" :key="i" :class="item.value==navClick?'active':null">
								{{item.label}}<span class="badge_defult" :class="tableCount[item.value]&&tableCount[item.value]>0?'badge_red':null">{{tableCount[item.value]|more99Filter}}</span>
							</p>
						</div> -->
						<el-dropdown v-show="!isShow" trigger="click" class="lh_dropdown">
							<span>{{navLabelObj['label']}}
								<span class="badge_defult" :class="tableCount[navLabelObj['value']]&&tableCount[navLabelObj['value']]>0?'badge_red':null">{{tableCount[navLabelObj['value']]|more99Filter}}</span>
								<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="(item,i) in navList" :key="i" >
									<p class="dropdown_p" @click="navClickHandle(item.value,item.label)" :class="item.value==navClick?'active':null">
										{{item.label}}<span class="badge_defult" :class="tableCount[item.value]&&tableCount[item.value]>0?'badge_red':null">{{tableCount[item.value]|more99Filter}}</span>
									</p>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<el-input class="my_input" v-model="dealSearchkey" placeholder="请输入项目编号/名称">
							<i slot="suffix" class="el-input__icon el-icon-search" @click="dealSearch"></i>
						</el-input>
					</div>
					<div class="deal_matter_table scroll_hidden" @mouseover="mymouseIn" @mouseout="mymouseOut">
						<!-- 工程建设、政府采购、国土交易、国有产权 -->
						<el-table size="mini" v-show="['GC','CG','GT','CQ'].includes(navClick)" ref="filterTable"
							v-loading="fullscreenLoading" :data="tableData" style="width:100%;" class="table_compatible--small" 
							:header-cell-style="tableHeadStyle" @filter-change="filterChange" @sort-change="sortChange">
							<el-table-column align="center" label="序号" width="80px" type="index" :index="indexMethod"></el-table-column>
							<el-table-column label="项目/标段编号" prop="buyprojectCode" min-width="150px"></el-table-column>
							<el-table-column label="项目/标段名称" prop="field3" min-width="250px" show-overflow-tooltip></el-table-column>
							<el-table-column label="业务节点" prop="field1" min-width="120px" 
								:filters="busynessNode" column-key="field1" :filtered-value="field1CheckList">
								<template slot-scope="scope">
									{{scope.row.field1}}
								</template>
							</el-table-column>
							<el-table-column align="center" label="提交时间" min-width="140px" prop="createDate" sortable="createDate"></el-table-column>
							<el-table-column align="center" label="操作" width="100px" fixed="right">
								<template slot-scope="scope">
									<el-button type="text" size="mini" @click="routerTo(scope.row)">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
						<!-- 协同办公 -->
						<div v-show="['XT'].includes(navClick)">
							<el-table size="mini" v-loading="fullscreenLoading" :data="tableData" style="width:100%;" class="table_compatible--small" :header-cell-style="tableHeadStyle" @row-click="xtbgRowClick">
								<el-table-column align="center" label="序号" width="80px" type="index" :index="indexMethod"></el-table-column>
								<el-table-column label="日程内容" prop="title" min-width="180px" show-overflow-tooltip></el-table-column>
								<el-table-column label="开始时间" prop="startTime" min-width="140px"></el-table-column>
								<el-table-column label="结束时间" prop="endTime" min-width="140px"></el-table-column>
								<el-table-column align="center" label="地点" min-width="160px" prop="location"></el-table-column>
								<el-table-column align="center" label="紧急程度" min-width="100px" prop="emergencyLevel">
									<template v-slot="scope">
										{{scope.row.emergencyLevel|emergencyLevelFilter}}
									</template>
								</el-table-column>
								<el-table-column align="center" label="备注" min-width="120px" prop="remark" show-overflow-tooltip></el-table-column>
								<el-table-column label="操作" width="120px" fixed="right">
									<template v-slot="scope">
										<div class="schcz">
											<span class="schbtns">
												<el-button type="text" size="mini" @click="schHandle(1,scope.row.id)">完成</el-button>
												&nbsp;&nbsp;|&nbsp;&nbsp;
												<el-button type="text" size="mini" @click="schHandle(2,scope.row.id)">删除</el-button>
											</span>
											<span class="my_icon el-icon-top" @click="schMove(1,scope.row.id)"></span>
											<span class="my_icon el-icon-bottom" @click="schMove(2,scope.row.id)"></span>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="xt_add_btn" @click="schAdd"><i class="el-icon-plus"></i>添加</div>
						</div>
						<!-- 其他 -->
						<el-table size="mini" v-show="['QT'].includes(navClick)" v-loading="fullscreenLoading" :data="tableData" style="width:100%;" class="table_compatible--small" :header-cell-style="tableHeadStyle">
							<el-table-column align="center" label="序号" width="80px" type="index" :index="indexMethod"></el-table-column>
							<el-table-column label="标题" prop="" min-width="160px"></el-table-column>
							<el-table-column label="提交时间" prop="" min-width="300px" show-overflow-tooltip></el-table-column>
							<el-table-column label="备注" prop="" min-width="100px"></el-table-column>
							<el-table-column align="center" label="操作" width="100px" fixed="right">
								<template>
									<el-button type="text" size="mini">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="limit" v-if="paginationOpt1.total>=paginationOpt1.pageSize">
						<pagination
							v-show="bidTotal>7"
							class="limit"
							:page-sizes="[7, 14, 21, 28,35]"
							:total="bidTotal"
							:page.sync="bidQuery.page"
							:limit.sync="bidQuery.limit"
							@pagination="getBidData"
						/>
					</div>
				</el-card>
</template>
<script>
import Pagination from '@/components/Pagination'
import {navList} from '@/utils/index';

import {quickList,checkNav,gcjsFilterList,zfcgFilterList,gtjyFilterList,gycqFilterList} from '@/utils/busyness';
import {
	apiAuditList,apiwbschedulemanagementlist,apiworkBenchIndexProjectIndex,
	apiAuditCount,apijwtToJsgc,apijwtToZfcg,apijwtToBjm,apijwtToField,apiwbschedulemanagementupdateCompleteStatus,
	apiwbschedulemanagementdelete,apiwbschedulemanagementmove,apiwbconveniententranceconvenientEntranceList,
	apiwbconveniententrancedelete,apiwbconveniententrancedeleteCustomize,
	apiwbconveniententrancesort,apijwtToSystem,apifilePath} from '@/server/common';


export default {
    components: {
        Pagination
    },
	data() {
		return {
			fullscreenLoading:false,
			dialogVisible:false,
			navList:navList,
			navClick:'GC',
			navLabelObj:{
				value:"GC",
				label:"工程建设"
			},
			dealSearchkey:'',
			tableCount:{},//待办事项计算数
			// 待办事项数据
			tableData:[],
			// 通知消息数据
			noticeMsg:[],
			// 今日开标数据
			paginationOpt1:{
				pageIndex:1,
				pageSize:5,
				total:0,
				pageSizes:[5,10,15]
			},
			isVisiter:false,
			quickChooseValue:'',
			isShow:true,
			busynessNode:gcjsFilterList,
			field1CheckList:[],
			sortCheckObj:{},
			fastFnData:[],
			tableHeadStyle: {}
		}
	},
	mounted() {
		this.apiAuditCount();
		this.apiAuditList();
		this.isShow=document.body.clientWidth<1500?false:true;
	},
    methods: {
		schAdd(){
			this.isVisiter=true;
		},
		// 获取文件服务器地址
		apifilePath(){
			apifilePath().then((res)=>{
				const {data} = res;
				this.fileServerUrl=data;
			})
		},
			// 待办的筛选功能
		filterChange(arg){
			this.field1CheckList=arg.field1;
			this.apiAuditList();
		},
		// 待办的排序功能
		sortChange(arg){
			this.sortCheckObj=arg;
			this.apiAuditList();
		},
		clearFilter() {
			this.$refs.filterTable.clearFilter();
		},
		clearSort(){
			this.$refs.filterTable.clearSort();
		},
		// 待办事项刷新
		dealReflash(){
			this.dealSearchkey='';
			this.busynessNode=gcjsFilterList;
			this.field1CheckList=[];
			this.sortCheckObj={};
			this.clearFilter();
			this.clearSort();
			let temp=checkNav(this.navClick);
			this.paginationOpt1=temp.opt;
			if(temp.type){
				this.apiAuditList();
			}else{
				this.apiwbschedulemanagementlist();
			}
			this.apiAuditCount();
		},
		// 待办搜索事件
		dealSearch(){
			let temp=checkNav(this.navClick);
			this.paginationOpt1=temp.opt;
			if(temp.type){
				this.apiAuditList();
			}
			this.navClick=='XT'&&this.apiwbschedulemanagementlist();
			this.apiAuditCount();
		},
		apiwbschedulemanagementlist(){
			this.fullscreenLoading=true;
			apiwbschedulemanagementlist({
				page:this.paginationOpt1.pageIndex,
                rows:this.paginationOpt1.pageSize,
				filter:{
					// field2:this.navClick||'',
					searchKey:this.dealSearchkey,
					completeStatus:0
				}
			}).then(({data})=>{
				this.tableData=data.rows||[];
				this.paginationOpt1.total=data.total||0;
			}).finally(()=>{this.fullscreenLoading=false})
		},
		apiAuditCount(){
			apiAuditCount({
				page:this.paginationOpt1.pageIndex,
                rows:this.paginationOpt1.pageSize,
				filter:{
					field2:this.navClick||'',
					searchKey:this.dealSearchkey,
					historyid:-1
				}
			}).then(({data})=>{
				if(data.code=='1'){
					this.tableCount=data.data;
				}
			})
		},
		// 待办事项初始化-工程建设政府采购国土交易国有产权
		apiAuditList(){
			this.fullscreenLoading=true;
			let temp='';
			if(this.field1CheckList.length==0){
				temp=null;
			}else{
				temp=this.field1CheckList;
			}
			apiAuditList({
				page:this.paginationOpt1.pageIndex,
                rows:this.paginationOpt1.pageSize,
				filter:{
					field2:this.navClick||'',
					searchKey:this.dealSearchkey,
					historyid:-1,
					orderByType:!this.sortCheckObj.order?'DESC':this.sortCheckObj.order=='ascending'?'ASC':'DESC',
					businessNodeList:temp
				},
			}).then((res)=>{
				const {data} = res;
				if(data.code=='1'){
					this.tableData=data.data.rows||[];
					this.paginationOpt1.total=data.data.total||0;
				}
			}).finally(()=>{this.fullscreenLoading=false})
		},
		// 待办事项-协同办公
		apiwbschedulemanagementlist(){
			this.fullscreenLoading=true;
			apiwbschedulemanagementlist({
				page:this.paginationOpt1.pageIndex,
                rows:this.paginationOpt1.pageSize,
				filter:{
					// field2:this.navClick||'',
					searchKey:this.dealSearchkey,
					completeStatus:0
				}
			}).then(({data})=>{
				this.tableData=data.rows||[];
				this.paginationOpt1.total=data.total||0;
			}).finally(()=>{this.fullscreenLoading=false})
		},
		// 序号
        indexMethod(index){
            return (this.paginationOpt1.pageIndex - 1) * this.paginationOpt1.pageSize + index + 1
        },
		navClickHandle(value,label){
			let newTemp={
				'GC':gcjsFilterList,
				'CG':zfcgFilterList,
				'GT':gtjyFilterList,
				'CQ':gycqFilterList
			}
			this.busynessNode=newTemp[value];
			this.field1CheckList=[];
			this.sortCheckObj={};
			this.clearFilter();
			this.clearSort();
			this.dealSearchkey='';
			this.navClick=value;
			this.navLabelObj={
				value,label
			};
			let temp=checkNav(this.navClick);
			this.paginationOpt1=temp.opt;
			if(temp.type=='QT'){
				this.tableData=[];
			}else{
				if(temp.type){
					this.apiAuditList();
				}
			}
			this.navClick=='XT'&&this.apiwbschedulemanagementlist();
			this.apiAuditCount();
		},
		apiAuditList(){
			this.fullscreenLoading=true;
			let temp='';
			if(this.field1CheckList.length==0){
				temp=null;
			}else{
				temp=this.field1CheckList;
			}
			apiAuditList({
				page:this.paginationOpt1.pageIndex,
                rows:this.paginationOpt1.pageSize,
				filter:{
					field2:this.navClick||'',
					searchKey:this.dealSearchkey,
					historyid:-1,
					orderByType:!this.sortCheckObj.order?'DESC':this.sortCheckObj.order=='ascending'?'ASC':'DESC',
					businessNodeList:temp
				},
			}).then((res)=>{
				const {data} = res;
				if(data.code=='1'){
					this.tableData=data.data.rows||[];
					this.paginationOpt1.total=data.data.total||0;
				}
			}).finally(()=>{this.fullscreenLoading=false})
		},

		closeSch(data){
			this.isVisiter=false;
			data&&this.apiwbschedulemanagementlist();
		},
		// 查看一周开评标场地表
		apijwtToField(){
			apijwtToField().then(({data})=>{
				if(data.code=='1'){
					window.open(data.data)
				}else{
					this.$alert(data.msg);
				}
			})
		},
		routerTo(item){
			apijwtToJsgc({redUrl:item.field4,title:item.field1,field2:item.field2}).then(({data})=>{
				if(data.code=='1'){
					addPanel('待办详情',data.data)
				}else{
					this.$alert(data.msg);
				}
			})
		},
		// 今日开标/竞价项目摄像头点击
		open(type,bidId){
			apijwtToBjm(bidId).then(({data})=>{
				if(data.code=='1'){
					window.open(data.data);
				}else{
					this.$alert(data.msg);
				}
			})
		},

				// 协同办公某一行点击事件
				xtbgRowClick(row, column, event){
			if(column.label!='操作'){
				this.isVisiter=true;
				this.$refs.schdialog.apiwbschedulemanagementget(row.id);
			}
		},
		// 协同办公功能操作
		schHandle(type,id){
			let tempTypeList={
				1:'完成',
				2:'删除'
			};
			this.$confirm(`是否${tempTypeList[type]}该协同办公数据？`,'提示',{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(()=>{
				type==1&&apiwbschedulemanagementupdateCompleteStatus(id).then(({data})=>{
					if(data.code=='1'){
						this.$message({
							type:'success',
							message:'完成成功'
						})
						this.navClick=='XT'&&this.apiwbschedulemanagementlist();
						this.apiAuditCount();
					}else{
						this.$message({
							type:'error',
							message:data.msg
						})
					}
				})
				type==2&&apiwbschedulemanagementdelete(id).then(({data})=>{
					if(data.code=='1'){
						this.$message({
							type:'success',
							message:'删除成功'
						})
						this.navClick=='XT'&&this.apiwbschedulemanagementlist();
						this.apiAuditCount();
					}else{
						this.$message({
							type:'error',
							message:data.msg
						})
					}
				})
			}).catch(()=>{})
		},
		// 协同办公上移下移操作
		schMove(type,id){
			apiwbschedulemanagementmove({id,type}).then(({data})=>{
				if(data.code=='1'){
					this.navClick=='XT'&&this.apiwbschedulemanagementlist();
					this.apiAuditCount();
				}else{
					this.$message.error(data.msg);
				}
			})
		},
		
	},
}
</script>

<style lang="less">
.my_input{
	width: 18% !important;
	min-width: 200px;
	margin-left: auto;
	.el-input__icon{
		cursor: pointer;
	}
}

.deal_matter{
			.title{
				display: flex;
				justify-content: flex-start;
				align-items: center;
				.title_nav{
					margin-left: 10px;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					font-size: 14px;
					p{
						padding: 10px 10px 10px 0;
						cursor: pointer;
						position: relative;
						margin: 0;
						span{
							// padding: 0 2px;
							margin-left: 3px;
						}
						&:after{
							content: '';
							width: 0%;
							height: 2px;
							background: #1890FF;
							position: absolute;
							bottom: 0;
							left: 0;
							transition: all 0.7s;
						}
						&:hover{
							color: #1890FF;
						}
						&:hover:after{
							width: 100%;
						}
					}
					.active{
						color: #1890FF;
						&:after{
							width: 100%;
						}
					}
				}
				.lh_dropdown{
					margin-left: 10px;
				}
				.my_input{
					width: 18%;
					min-width: 200px;
					margin-left: auto;
					.el-input__icon{
						cursor: pointer;
					}
				}
			}
			.deal_matter_table{
				width: 100%;
				height: calc(100% - 102px);
				padding: 3px 10px 0 20px;
				overflow: auto;
				.xt_add_btn{
					margin-top: 10px;
					width: 100%;
					text-align: center;
					border: 1px dashed #ebeef5;
					border-radius: 5px;
					height: 30px;
					line-height: 30px;
					cursor: pointer;
				}
				.schcz{
					display: flex;
					align-items: center;
					span.my_icon{
						font-size: 14px;
						margin-left: 5px;
						cursor: pointer;
					}
					.schbtns{
						display: flex;
						.el-button{
							display: block;
							margin: 0;
							padding: 0;
						}
					}
				}
			}
			.limit{
				text-align: right;
				margin-right: 10px;
				/deep/ .el-pagination{
					margin-top: 13px;
					padding-bottom: 0;
				}
			}
		}
</style>